<template lang='pug'>
    div(height='100vh')
        v-img.window-display-image(:src="imgUrl" contain max-height="1280" style="margin-top:50px;")
</template>

<script>
export default {
    name: 'UpPortalDisplayImage',
    data() {
        return{
            imgUrl: '',
        }
    },
    created() {
        const storageKey = 'doc_image_url_temp';
        const img = localStorage.getItem(storageKey);
        if (img) {
            this.imgUrl = img;
            localStorage.removeItem(storageKey); // 顯示後移除，避免殘留
        }else{
            window.close()
        }
    },
    methods: {}
}
</script>

<style scoped lang="css">

</style>